import {Locale} from 'next-intl';
import {JSX} from 'react';
import ArticleNote from '../modules/ArticleNote';
import FormBuilder from '../modules/FormBuilder';
import ImageText from '../modules/ImageText';
import PrivacyCode from '../modules/PrivacyCode';
import ReservationFormBuilder from '../modules/ReservationFormBuilder';
import Slider from '../modules/Slider';
import Table from '../modules/Table';
import Template from '../modules/Template';
import {genHash} from './utils';

type GetLayoutProps = {
  locale: Locale;
  moduleSlug: string;
  moduleName: string;
  moduleData: any;
  moduleOption: any;
  options: any;
};

export default function getLayout(props: GetLayoutProps): JSX.Element {
  const {locale, moduleSlug, moduleName, moduleData, moduleOption, options} =
    props;
  const hash = genHash();

  switch (moduleName) {
    case 'template':
      return <Template {...{moduleOption, moduleData}} />;

    case 'table':
      return <Table {...{moduleOption}} />;

    case 'slider':
      return <Slider {...{moduleOption, moduleData}} />;

    case 'form':
      return (
        <FormBuilder
          page_slug={options?.page?.slug || moduleSlug}
          form_slug={moduleSlug}
          meta={{...moduleOption, hash}}
        />
      );

    case 'note':
      return <ArticleNote {...{moduleOption}} />;

    case 'image-text':
      return <ImageText {...{moduleOption}} />;

    case 'reservation-form':
      return (
        <ReservationFormBuilder
          page_slug={options?.page?.slug || moduleSlug}
          form_slug={moduleSlug}
          meta={{...moduleOption, hash}}
        />
      );
    case 'privacy-code':
      return <PrivacyCode />;

    default:
      return <></>;
  }
}
